"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPanel = void 0;
const Leaf = __importStar(require("leaf-ts"));
require("@branch-ts/business-consensus");
const presentMechanism_1 = require("@branch-ts/web-consensus/src/presentMechanism");
const web_1 = require("@branch-ts/web");
const subscriptionPanel_html_R_1 = require("./subscriptionPanel/subscriptionPanel.html.R");
const subscriptionPanel_html_R_2 = require("./subscriptionPanel/subscriptionPanel.theme/business/subscriptionPanel.html.R");
const subscriptionPanel_html_R_3 = require("./subscriptionPanel/subscriptionPanel.theme/genesis/subscriptionPanel.html.R");
const planCheckout_1 = require("../market/planCheckout");
const subscriptionTier_1 = require("./subscriptionTier");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
class SubscriptionPanel extends subscriptionPanel_html_R_1.R.SubscriptionPanel {
    constructor() {
        super();
        this.subscription = null;
        this.plans = [];
        this.currentCheckoutURI = null;
        this.cancelling = false;
        this.presentContext = presentMechanism_1.PresentMechanism.ensure(this)
            .lifeCycle(async (declares) => {
            await declares.declare("configure");
            await declares.declare("present");
            await this.refresh();
            await declares.declare("hang");
        });
        this.stages = new web_1.StagesBehavior(this).defines({
            state: "free",
            paymentStatus: "none",
            hasPrevail: "hide",
            hasDue: "hide",
            hasPlanView: "hide",
            hasPlanDescription: "hide",
            cancellationConfirmation: "hide"
        });
        this.fault = (0, web_1.FatUIErrorBestPractice)();
    }
    async refresh() {
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        let [res, reason, ...errors] = await server.rpcs.VersetUserSubscriptionService.getMySubscription({});
        this.fault.caution.worry({
            message: "Failed to get subscription",
            reason: reason,
            errors: errors
        });
        this.subscription = res.subscription;
        this.plans = res.plans || [];
        this.currentCheckoutURI = res.checkoutURI || null;
        this.renderSubscription(res.subscription);
    }
    renderSubscription(subscription) {
        const tier = (0, subscriptionTier_1.subscriptionTier)(subscription);
        const planView = this.plans.find(plan => plan.name === (tier.className === "tier-paid" ? subscription.prevail.plan : "free"));
        this.VM.plan = tier.name;
        this.VM.tierClass = (0, subscriptionTier_1.subscriptionTier)(subscription).className;
        this.stages.set("state", subscription.state || "free");
        this.stages.set("paymentStatus", this.computePaymentStatus(subscription));
        const cancelled = subscription.prevail?.accident === "cancelNext" || subscription.state === "activeCancelledNext" || subscription.state === "activeCancellingNext";
        this.VM.renewalStatus = subscription.state.startsWith("active")
            ? cancelled ? `Renewal stopped. Your paid access ends on ${new Date(subscription.prevail.end).toLocaleString()}. Then your account returns to Free.`
                : "Your subscription renews automatically. Cancellation stops the next cycle and keeps your current paid access."
            : "No active paid renewal.";
        this.UI.cancelSubscription.disabled = this.cancelling || cancelled || !subscription.state.startsWith("active") || !subscription.paymentSubscriptionHandle;
        this.UI.confirmCancellation.disabled = this.cancelling;
        this.UI.keepSubscription.disabled = this.cancelling;
        this.VM.cancelActionText = this.cancelling ? "Stopping renewal…" : "Confirm cancellation";
        if (subscription.prevail) {
            this.stages.set("hasPrevail", "show");
            this.VM.privilegeStart = new Date(subscription.prevail.start).toLocaleDateString();
            this.VM.privilegeEnd = new Date(subscription.prevail.end).toLocaleDateString();
        }
        else {
            this.stages.set("hasPrevail", "hide");
        }
        if (subscription.due) {
            this.stages.set("hasDue", "show");
            this.VM.dueStart = new Date(subscription.due.start).toLocaleDateString();
            this.VM.dueEnd = new Date(subscription.due.end).toLocaleDateString();
        }
        else {
            this.stages.set("hasDue", "hide");
        }
        if (planView) {
            this.stages.set("hasPlanView", "show");
            this.VM.planUnit = planView.duration;
            this.VM.planPrice = `${planView.amount !== undefined ? planView.amount : planView.exactAmount} ${planView.currency.toUpperCase()}`;
            this.VM.planQuota = planView.name === "free"
                ? "Monthly AI usage included"
                : `$${planView.quotaPoint / 10_000} of AI usage each cycle`;
            this.VM.planDescription = planView.name === "standard"
                ? "For regular AI-assisted work across supported models"
                : planView.description || "Monthly AI usage included";
            if (planView.description) {
                this.stages.set("hasPlanDescription", "show");
            }
            else {
                this.stages.set("hasPlanDescription", "hide");
            }
        }
        else {
            this.stages.set("hasPlanView", "hide");
            this.stages.set("hasPlanDescription", "hide");
            this.VM.planQuota = "";
        }
    }
    computePaymentStatus(subscription) {
        // A retained checkout URL and the next renewal cycle are not evidence
        // of an unfinished checkout. Prefer the current paid entitlement.
        if (subscription.state.startsWith("active") && subscription.prevail && subscription.prevail.accident !== "cancelNow" && Date.now() < subscription.prevail.end) {
            return "active";
        }
        if (subscription.due || subscription.state.includes("Collecting")) {
            return "due";
        }
        if (this.currentCheckoutURI) {
            return "checkout";
        }
        return "none";
    }
    async onClickUpgrade(e) {
        e?.stopPropagation();
        e?.preventDefault();
        planCheckout_1.PlanCheckout.show();
    }
    async onClickGoCheckout(e) {
        e?.stopPropagation();
        e?.preventDefault();
        planCheckout_1.PlanCheckout.show();
    }
    async onClickFixIt(e) {
        e?.stopPropagation();
        e?.preventDefault();
        planCheckout_1.PlanCheckout.show();
    }
    onClickCancelSubscription(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (this.UI.cancelSubscription.disabled)
            return;
        this.stages.set("cancellationConfirmation", "show");
        this.VM.cancellationMessage = `Stop renewal? Keep your current paid access until ${new Date(this.subscription.prevail.end).toLocaleString()}. No refund is issued.`;
        this.UI.keepSubscription.focus();
    }
    onClickKeepSubscription(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (!this.cancelling) {
            this.stages.set("cancellationConfirmation", "hide");
            this.UI.cancelSubscription.focus();
        }
    }
    async onClickConfirmCancellation(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (this.cancelling || this.stages.get("cancellationConfirmation") !== "show" || this.UI.cancelSubscription.disabled)
            return;
        this.cancelling = true;
        this.renderSubscription(this.subscription);
        this.VM.cancellationFeedback = "Stopping renewal…";
        try {
            const [result, reason] = await versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer().rpcs.VersetUserSubscriptionService.cancelMySubscription({});
            if (reason) {
                this.VM.cancellationFeedback = "Could not confirm cancellation. Please retry. If renewal was already stopped, retrying safely reconciles it.";
                return;
            }
            this.subscription = result.subscription;
            this.currentCheckoutURI = null;
            this.stages.set("cancellationConfirmation", "hide");
            this.VM.cancellationFeedback = `Renewal stopped. Paid access remains until ${new Date(result.effectiveAt).toLocaleString()}.`;
        }
        catch {
            this.VM.cancellationFeedback = "Could not confirm cancellation. Please retry or contact support@verset.io.";
        }
        finally {
            this.cancelling = false;
            this.renderSubscription(this.subscription);
        }
    }
}
exports.SubscriptionPanel = SubscriptionPanel;
Leaf.WidgetThemeCenter.about(subscriptionPanel_html_R_1.R.SubscriptionPanel).add("business", subscriptionPanel_html_R_2.R.SubscriptionPanel.generator);
Leaf.WidgetThemeCenter.about(subscriptionPanel_html_R_1.R.SubscriptionPanel).add("genesis", subscriptionPanel_html_R_3.R.SubscriptionPanel.generator);
